import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../../services/authService';
import './AuthCallback.css';

const AuthCallback: React.FC = () => {
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [debugInfo, setDebugInfo] = useState<string>('');
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      console.log('AuthCallback mounted. Processing OAuth callback...');
      try {
        // Get the authorization code from URL
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const error = urlParams.get('error');
        const errorDescription = urlParams.get('error_description');

        console.log('URL params:', {
          code: code ? `${code.substring(0, 5)}...` : null,
          error,
          errorDescription
        });

        // If there's an error in the URL, show it
        if (error) {
          setStatus('error');
          setErrorMessage(`Authentication error: ${error} - ${errorDescription?.replace(/\+/g, ' ') || 'Unknown error'}`);
          console.error('OAuth error:', error, errorDescription);
          return;
        }

        if (!code) {
          setStatus('error');
          setErrorMessage('No authorization code found in URL.');
          setDebugInfo(`Full URL: ${window.location.href}`);
          console.error('No code found in URL:', window.location.href);
          return;
        }

        // Exchange the code for an access token
        console.log('Exchanging code for token...');
        await authService.exchangeCodeForToken(code);
        console.log('Token exchange successful!');
        
        // If successful, update status and redirect
        setStatus('success');
        setTimeout(() => {
          navigate('/');
        }, 2000);
      } catch (error: any) {
        console.error('Error during OAuth callback:', error);
        setStatus('error');
        setErrorMessage(`Authentication failed: ${error.message || 'Unknown error'}`);
        setDebugInfo(`Check browser console for detailed error information.`);
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="auth-callback">
      {status === 'loading' && (
        <div className="auth-loading">
          <h2>Completing authentication...</h2>
          <div className="spinner"></div>
        </div>
      )}
      
      {status === 'success' && (
        <div className="auth-success">
          <h2>Authentication successful!</h2>
          <p>Redirecting you back to the application...</p>
        </div>
      )}
      
      {status === 'error' && (
        <div className="auth-error">
          <h2>Authentication Error</h2>
          <p>{errorMessage}</p>
          {debugInfo && <pre className="debug-info">{debugInfo}</pre>}
          <button onClick={() => navigate('/')}>Return to App</button>
        </div>
      )}
    </div>
  );
};

export default AuthCallback; 